import constate from 'constate'

import useMapReference from '@ecm/ui/hook/UseMapReference'

const [MapReferenceProvider, useMapReferenceContext] = constate(useMapReference)
export { MapReferenceProvider, useMapReferenceContext }
